import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { Route } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import styles from "./mailThread.module.scss";
import Mail from "./mail";
import ComposeMail from "./compose";

class MailThread extends Component {
	constructor(props) {
		super(props);
		this.state = {
			height: 0,
			shouldScroll: true,
			isHovered: false,
			currentActorId: -1
		};
	}

	componentDidMount() {
		this.scrollWithoutReply();
		this.scrollToBottom();
		const height = this.mailThreadDiv.clientHeight;
		this.setState({ height });
	}

	componentDidUpdate() {
		if (!this.props.match.url.includes("tutorial")) {
			if (
				this.state.shouldScroll &&
				this.checkIfLastMailIsReplyMail(this.props.location)
			) {
				this.scrollToBottom();
				let height = this.mailThreadDiv.clientHeight;

				if (this.state.height !== height) {
					this.setState({ height });
				} else {
					this.setState({ shouldScroll: false });
				}
			}
		}
	}

	componentWillReceiveProps = nextProps => {
		if (!this.checkIfLastMailIsReplyMail(nextProps.location)) {
			this.setState({ shouldScroll: true });
			// this.scrollWithoutReply();
		}
	};

	shouldComponentUpdate = (nextProps, nextState) => {
		if (
			!this.getMailReadFlag(nextProps.lastMail.actionThread) &&
			this.props.lastMail !== nextProps.lastMail
		) {
			this.props.addMailReadFlag(this.props.lastMail.id);
		}
		return true;
	};

	checkIfLastMailIsReplyMail = location => {
		return location.pathname.includes("reply");
	};

	getMailReadFlag = actionThread => {
		return actionThread.some(action => action.type === "mail_read");
	};

	scrollToBottom = () => {
		const node = ReactDOM.findDOMNode(this.composeMailDiv);

		if (node) {
			node.scrollIntoView({ behavior: "smooth" });
		}
	};

	scrollWithoutReply = () => {
		const objDiv = ReactDOM.findDOMNode(this.mailThreadDiv);
		// var objDiv = document.getElementById("your_div");

		if (objDiv) {
			objDiv.scrollTop = objDiv.scrollHeight;
		}
	};

	//display actor details as a tooltip, on hover
	getActorDetailsOnHover = actor => {
		return (
			<ReactTooltip className={styles.actorcard}>
				<div className="node-contents" style={{ padding: "0" }}>
					<div className="image-container">
						<img className="node-image" src={actor.gravatar} />
					</div>
					<div className="text">
						<div className="name">
							{`${actor.first_name} ${actor.last_name}`}
						</div>
						<div>
							{actor.role}
							{actor.company ? "," : null}
						</div>
						<div>{actor.company}</div>
					</div>
				</div>
			</ReactTooltip>
		);
	};

	setIsHoveredFlag = id => {
		this.setState({
			isHovered: true,
			currentActorId: id
		});
	};

	removeIsHoveredFlag = () => {
		this.setState({
			isHovered: false,
			currentActorId: -1
		});
	};

	showMailThread = (currentMailResponse, match, lastMail) => {
		let threadLength = currentMailResponse.length;

		return currentMailResponse.map((mailItem, index) => {
			return (
				<Mail
					{...mailItem}
					key={index}
					match={match}
					lastMail={lastMail}
					actors={this.props.actors}
					currentTime={this.props.getTimeData().timeLeft}
					getTimeData={this.props.getTimeData}
					autoSaveSurveyAnswers={this.props.autoSaveSurveyAnswers}
					setSurveyCompleteFlag={this.props.setSurveyCompleteFlag}
					showButtons={
						!this.checkIfLastMailIsReplyMail(this.props.location)
					}
					startCall={this.props.startCall}
					isCallCompleted={this.props.isCallCompleted}
					addMailStarredFlag={this.props.addMailStarredFlag}
					removeMailStarredFlag={this.props.removeMailStarredFlag}
					//for displaying actor details on hover
					getActorDetailsOnHover={this.getActorDetailsOnHover}
					setIsHoveredFlag={this.setIsHoveredFlag}
					removeIsHoveredFlag={this.removeIsHoveredFlag}
					isHovered={this.state.isHovered}
					currentActorId={this.state.currentActorId}
					//Self actor id
					selfActor={this.props.selfActor}
				/>
			);
		});
	};

	goBack = () => {
		window.location.href = window.location.href
			.split("/")
			.slice(0, -1)
			.join("/");
	};

	render() {
		const {
			currentMail,
			currentMailResponse,
			match,
			postData,
			saveDraft,
			setSurveyCompleteFlag,
			getTimeData,
			lastMail,
			actors,
			orgChart,
			selfActor
		} = this.props;

		let hideMailsForTutorial = false;

		if (
			this.props.match.url.includes("tutorial") &&
			this.props.location.pathname.includes("reply")
		) {
			hideMailsForTutorial = true;
		}

		return (

			<div
				className={styles.container}
				ref={el => {
					this.mailThreadDiv = el;
				}}
			>
				{!hideMailsForTutorial ? (
					<Mail
						{...currentMail}
						key="primary"
						goBack={this.goBack}
						match={match}
						lastMail={lastMail}
						actors={actors}
						//this thing is causing pages to re render?
						currentTime={getTimeData().timeLeft}
						getTimeData={this.props.getTimeData}
						autoSaveSurveyAnswers={this.props.autoSaveSurveyAnswers}
						setSurveyCompleteFlag={setSurveyCompleteFlag}
						showButtons={
							!this.checkIfLastMailIsReplyMail(
								this.props.location
							)
						}
						startCall={this.props.startCall}
						isCallCompleted={this.props.isCallCompleted}
						addMailStarredFlag={this.props.addMailStarredFlag}
						removeMailStarredFlag={this.props.removeMailStarredFlag}
						//only for tutorial - not needed in mail therad part
						tutorial={this.props.tutorial}
						startTutorial={this.props.startTutorial}
						stopTutorial={this.props.stopTutorial}
						addStepsToTutorial={this.props.addStepsToTutorial}
						updateStepNumber={this.props.updateStepNumber}
						//for displaying actor details on hover
						getActorDetailsOnHover={this.getActorDetailsOnHover}
						setIsHoveredFlag={this.setIsHoveredFlag}
						removeIsHoveredFlag={this.removeIsHoveredFlag}
						isHovered={this.state.isHovered}
						currentActorId={this.state.currentActorId}
						//Self actor id
						selfActor={selfActor}
					/>
				) : null}

				{currentMailResponse &&
					this.showMailThread(currentMailResponse, match, lastMail)}

				{/*  router  to help compose  */}
				<Route
					path={match.url + "/:composeType"}
					render={props => (
						<ComposeMail
							match={props.match}
							postData={postData}
							saveDraft={saveDraft}
							getTimeData={getTimeData}
							primaryMailId={currentMail.id}
							lastMail={lastMail}
							actors={actors}
							parentHeight={this.state.height}
							orgChart={orgChart}
							isFirstMail={currentMail.isFirstMail}
							//only for tutorial - niot needed in mail therad part
							tutorial={this.props.tutorial}
							startTutorial={this.props.startTutorial}
							stopTutorial={this.props.stopTutorial}
							addStepsToTutorial={this.props.addStepsToTutorial}
							updateStepNumber={this.props.updateStepNumber}
							startCall={this.props.startCall}
							ref={el => {
								this.composeMailDiv = el;
							}}
							//Self actor id
							selfActor={selfActor}
						/>
					)}
				/>
			</div>
		);
	}
}

MailThread.propTypes = {};

MailThread.defaultProps = {};

export default MailThread;



// WEBPACK FOOTER //
// /src/components/mailThread/MailThread.js